import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { numberWithCommas } from "../../../../components/helpers";
import Table from "../../../../components/tables/tableCols1";
import TableSkeleton from "../../../../components/skeleton/table";
import TableFilter from "../../../../components/tables/tableFilter";
import { PaginationNoRoute } from "../../../../components/pagination/paginationNoRoute";
import EmptyState from "../../../../assets/images/icons/ShippersEmpty.svg";
import { CreateServiceArea } from "../../../../components/modals/admin/shippers/createServiceArea";
import UpdateServiceArea from "../../../../components/modals/admin/shippers/updateServiceArea";
import {
  filterServiceAreas,
  searchServiceAreas,
} from "../../../../redux/serviceAreas/serviceAreasActions";
import serviceAreaType from "../../../../redux/serviceAreas/serviceAreasTypes";

export default function AllServiceAreas() {
  const dispatch = useDispatch();
  const updateAreaRef = React.useRef(null);
  let params = useParams();

  const { allServiceAreas, filtering, searching } = useSelector(
    (state) => state.serviceArea
  );

  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [payLoad] = useState({ end_date: new Date() });
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [input, setInput] = useState({
    search: "",
  });

  useEffect(() => {
    dispatch(filterServiceAreas(payLoad, page));

    // eslint-disable-next-line
  }, [payLoad, page]);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((order) => {
        let show = {
          title: order?.area,
          charge: <span>NGN {numberWithCommas(order?.charge)}</span>,
          longitude: order?.longitude ?? "Not available",
          latitude: order?.latitude ?? "Not available",
          date: moment(order?.created_at).format("MMM DD, YYYY"),
          orderData: order,
        };
        outputArray.push({ show });
        return true;
      });
      return outputArray;
    }
  }

  useEffect(() => {
    const dataSet = createTableData(allServiceAreas?.data);
    setData(dataSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allServiceAreas]);

  const openUpdateModal = (params) => {
    let data = params?.show?.orderData;
    updateAreaRef.current.open();
    updateAreaRef.current.getServiceArea(data);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      doSearch();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const showSearch = (search) => {
    let dataSet = createTableData(search);
    setData(dataSet);
    setIsSearchOpen(true);
  };

  const removeSearch = () => {
    if (input?.search?.length === 0) {
      let dataSet = createTableData(allServiceAreas?.data);
      setData(dataSet);
      setIsSearchOpen(false);
      dispatch({
        type: serviceAreaType["SEARCH_SERVICE_AREAS"],
        payLoad: { data: [] },
      });
    }
  };

  async function doSearch() {
    try {
      let response = await dispatch(searchServiceAreas(input));
      if (response?.status === "success") {
        showSearch(response?.data);
      }
      if (!response?.status) {
        showSearch([]);
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (input?.search?.length === 0) {
      removeSearch();
    }
    // eslint-disable-next-line
  }, [input]);

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "Title",
            accessor: "show.title",
          },
          {
            Header: "Charge",
            accessor: "show.charge",
          },
          {
            Header: "Longitude",
            accessor: "show.longitude",
          },
          {
            Header: "Latitude",
            accessor: "show.latitude",
          },
          {
            Header: "Date Created",
            accessor: "show.date",
          },
        ],
      },
    ],
    []
  );

  return (
    <div data-test="">
      <TableFilter
        title={"Service Areas"}
        results={allServiceAreas?.data?.length}
        totalResults={allServiceAreas?.total}
        onChange={handleChange}
        handleKeyDown={handleKeyDown}
        payLoad={payLoad}
        page={params.page}
        searchPlaceholder={"Search by Area Name or Location"}
      >
        <CreateServiceArea />
      </TableFilter>

      <div className="border-b border-[#E4E4F3] dark:border-[#505050]"></div>

      <div className="bg-white dark:bg-[#121212] rounded-md py-8 px-3">
        {filtering || searching ? (
          <TableSkeleton />
        ) : data?.length > 0 ? (
          <Table
            columns={columns}
            data={data?.length > 0 ? data : []}
            onClick={openUpdateModal}
            className="w-full"
            rowClass="hover:shadow-md cursor-pointer"
          />
        ) : (
          <div className="text-center">
            <div className="flex justify-center">
              <img
                src={EmptyState}
                className="w-auto h-[160px]"
                alt="no data"
              />
            </div>
            <p className="font-bold text-xl my-3">Service Areas</p>
            <p className="text-sm text-gray-500">
              You have no service areas yet
            </p>
          </div>
        )}
        {!isSearchOpen ||
          (!data && (
            <PaginationNoRoute
              data={allServiceAreas}
              page={page}
              setPage={setPage}
            />
          ))}
      </div>
      <UpdateServiceArea ref={updateAreaRef} visibility={false} />
    </div>
  );
}
